import jp from "jsonpath";
import { FieldError } from "react-hook-form";

export function queryForError<T>(errors: T, path: string): FieldError[] {
  return jp.query(errors, path);
}
